import { render, staticRenderFns } from "./PartListsTab.vue?vue&type=template&id=e60cf58c"
import script from "./PartListTab.ts?vue&type=script&lang=ts&external"
export * from "./PartListTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports